// Avisos en este dispositivo: registra el service worker, pide permiso y guarda el token de FCM.
import { doc, setDoc, deleteDoc } from './fs';
import { getMessaging, getToken, deleteToken, isSupported } from 'firebase/messaging';
import { app, db } from './firebase';
// Dónde se recuerda el aviso push de este dispositivo (antes 'madvet-push'; se sigue leyendo para no perder los ya activados)
const CLAVE = 'vp-push';
const leerClave = () => localStorage.getItem(CLAVE) || localStorage.getItem('madvet-push');

export const esIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
export const instalada = () => window.matchMedia?.('(display-mode: standalone)').matches || navigator.standalone === true;

export async function registrarSW() {
  if (!('serviceWorker' in navigator)) return null;
  try { return await navigator.serviceWorker.register('/sw.js'); } catch { return null; }
}

// 'ok' | 'denegado' | 'no-soportado' | 'instalar-ios' | 'error: …'
export async function activarAvisos(user, perfil) {
  if (esIOS() && !instalada()) return 'instalar-ios';
  if (!(await isSupported().catch(() => false)) || typeof Notification === 'undefined') return 'no-soportado';
  const permiso = await Notification.requestPermission();
  if (permiso !== 'granted') return 'denegado';
  try {
    const reg = await registrarSW();
    const token = await getToken(getMessaging(app), { serviceWorkerRegistration: reg || undefined });
    if (!token) return 'error: no se obtuvo el token';
    await setDoc(doc(db, 'tokensPush', token), {
      uid: user.uid, org: perfil.org, nombre: user.displayName || user.email || '', rol: perfil.rol || '', clinicas: perfil.clinicas || [],
      dispositivo: navigator.userAgent.slice(0, 160), actualizado: new Date().toISOString(),
    });
    localStorage.setItem(CLAVE, token);
    return 'ok';
  } catch (e) { return `error: ${e.message}`; }
}

export async function desactivarAvisos() {
  try {
    const t = leerClave();
    if (t) await deleteDoc(doc(db, 'tokensPush', t)).catch(() => {});
    await deleteToken(getMessaging(app)).catch(() => {});
    localStorage.removeItem(CLAVE); localStorage.removeItem('madvet-push');
  } catch { /* nada */ }
}

// Al abrir el panel con los avisos ya activados, refresca el token (caduca de vez en cuando)
export async function refrescarAvisos(user, perfil) {
  try {
    if (typeof Notification === 'undefined' || Notification.permission !== 'granted' || !leerClave()) return;
    await activarAvisos(user, perfil);
  } catch { /* nada */ }
}
export const avisosActivos = () => { try { return typeof Notification !== 'undefined' && Notification.permission === 'granted' && !!leerClave(); } catch { return false; } };
